@if (initialized) {
  @if (step === 'customer') {
    <app-select-customer
      [emitAfterCreated]="false"
      [reloadAfterCreated]="true"
      [historyBack]="false"
      (back)="onCustomerBack()"
    (selected)="onCustomerSelected($event)"></app-select-customer>
  }
  @if (step === 'trial-phonenumber') {
    <app-order-trial-phonenumber
      (selected)="onTrialPhonenumberSelected($event)"
      (backEmitter)="onTrialPhonenumberBack()"
    [historyBack]="false"></app-order-trial-phonenumber>
  }
  @if (model?.domains && model?.domains?.length > 1 && step === 'domain') {
    <app-select-domain
      (selected)="onDomainSelected($event)"
      (back)="onDomainBack()"
    [domains]="model.domains"></app-select-domain>
  }
  @if (step === 'instance') {
    <app-select-instance-name
      (selected)="onInstanceNameSelected($event)"
      (backEmitter)="onSelectInstanceNameBack()"
      [isTrial]="true"
      [selectedDomain]="model.selectedDomain"
    selectedDomain=""></app-select-instance-name>
  }
  @if (step === 'phonenumber') {
    <app-phonenumber
      [hideBackButton]="true"
      (selected)="onPhonenumberSelected($event)"
    ></app-phonenumber>
  }
  @if (step === 'thank-you') {
    <app-cloud-thankyou
    [orderName]="model.saleOrder?.name"></app-cloud-thankyou>
  }
}
